import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {QueueJob, QueueJobListInput} from '../__generated__/resolvers-types';

export const LIST_QUEUE_JOB_QUERY = gql`
  query ListQueueJob($input: QueueJobListInput) {
    listQueueJob(input: $input) {
      id
      status
      creationTimestamp
      lastUpdateTimestamp
      etsyBulkCreateGdriveFolder {
        items {
          id
          status
          error
          name
        }
      }
      etsyBulkCreateGdriveFile {
        items {
          id
          status
          error
          name
        }
      }
      etsyBulkCreateCsv {
        items {
          id
          status
          error
        }
      }
      etsyBulkUpdateCsv {
        items {
          id
          status
          error
        }
      }
      imageToImageGeneration {
        items {
          id
          status
          error
        }
      }
    }
  }
`;

export function useListQueueJobQuery(params?: QueueJobListInput) {
  return useQuery<{listQueueJob: QueueJob[]}>(LIST_QUEUE_JOB_QUERY, {
    variables: {input: params},
    fetchPolicy: 'network-only',
  });
}
